window.TLNS_TIRE_FILTERS = {
  "generatedAt": "2026-05-19T00:19:32.233Z",
  "productCount": 523,
  "combinationCount": 299,
  "widths": [
    {
      "value": "2.50",
      "handle": "tire-width-2-50"
    },
    {
      "value": "2.75",
      "handle": "tire-width-2-75"
    },
    {
      "value": "3.00",
      "handle": "tire-width-3-00"
    },
    {
      "value": "7",
      "handle": "tire-width-7"
    },
    {
      "value": "9.50",
      "handle": "tire-width-9-50"
    },
    {
      "value": "10",
      "handle": "tire-width-10"
    },
    {
      "value": "10.50",
      "handle": "tire-width-10-50"
    },
    {
      "value": "11",
      "handle": "tire-width-11"
    },
    {
      "value": "11.50",
      "handle": "tire-width-11-50"
    },
    {
      "value": "12",
      "handle": "tire-width-12"
    },
    {
      "value": "12.50",
      "handle": "tire-width-12-50"
    },
    {
      "value": "13",
      "handle": "tire-width-13"
    },
    {
      "value": "13.50",
      "handle": "tire-width-13-50"
    },
    {
      "value": "14",
      "handle": "tire-width-14"
    },
    {
      "value": "15",
      "handle": "tire-width-15"
    },
    {
      "value": "15.00",
      "handle": "tire-width-15-00"
    },
    {
      "value": "15.50",
      "handle": "tire-width-15-50"
    },
    {
      "value": "60",
      "handle": "tire-width-60"
    },
    {
      "value": "65",
      "handle": "tire-width-65"
    },
    {
      "value": "70",
      "handle": "tire-width-70"
    },
    {
      "value": "80",
      "handle": "tire-width-80"
    },
    {
      "value": "90",
      "handle": "tire-width-90"
    },
    {
      "value": "100",
      "handle": "tire-width-100"
    },
    {
      "value": "110",
      "handle": "tire-width-110"
    },
    {
      "value": "120",
      "handle": "tire-width-120"
    },
    {
      "value": "130",
      "handle": "tire-width-130"
    },
    {
      "value": "140",
      "handle": "tire-width-140"
    },
    {
      "value": "150",
      "handle": "tire-width-150"
    },
    {
      "value": "160",
      "handle": "tire-width-160"
    },
    {
      "value": "180",
      "handle": "tire-width-180"
    },
    {
      "value": "185",
      "handle": "tire-width-185"
    },
    {
      "value": "190",
      "handle": "tire-width-190"
    },
    {
      "value": "195",
      "handle": "tire-width-195"
    },
    {
      "value": "200",
      "handle": "tire-width-200"
    },
    {
      "value": "205",
      "handle": "tire-width-205"
    },
    {
      "value": "215",
      "handle": "tire-width-215"
    },
    {
      "value": "225",
      "handle": "tire-width-225"
    },
    {
      "value": "235",
      "handle": "tire-width-235"
    },
    {
      "value": "245",
      "handle": "tire-width-245"
    },
    {
      "value": "255",
      "handle": "tire-width-255"
    },
    {
      "value": "265",
      "handle": "tire-width-265"
    },
    {
      "value": "275",
      "handle": "tire-width-275"
    },
    {
      "value": "285",
      "handle": "tire-width-285"
    },
    {
      "value": "295",
      "handle": "tire-width-295"
    },
    {
      "value": "305",
      "handle": "tire-width-305"
    },
    {
      "value": "315",
      "handle": "tire-width-315"
    },
    {
      "value": "325",
      "handle": "tire-width-325"
    },
    {
      "value": "335",
      "handle": "tire-width-335"
    },
    {
      "value": "345",
      "handle": "tire-width-345"
    },
    {
      "value": "385",
      "handle": "tire-width-385"
    }
  ],
  "aspectRatios": [
    {
      "value": "20",
      "handle": "tire-aspect-ratio-20"
    },
    {
      "value": "25",
      "handle": "tire-aspect-ratio-25"
    },
    {
      "value": "30",
      "handle": "tire-aspect-ratio-30"
    },
    {
      "value": "35",
      "handle": "tire-aspect-ratio-35"
    },
    {
      "value": "40",
      "handle": "tire-aspect-ratio-40"
    },
    {
      "value": "45",
      "handle": "tire-aspect-ratio-45"
    },
    {
      "value": "50",
      "handle": "tire-aspect-ratio-50"
    },
    {
      "value": "55",
      "handle": "tire-aspect-ratio-55"
    },
    {
      "value": "60",
      "handle": "tire-aspect-ratio-60"
    },
    {
      "value": "65",
      "handle": "tire-aspect-ratio-65"
    },
    {
      "value": "70",
      "handle": "tire-aspect-ratio-70"
    },
    {
      "value": "75",
      "handle": "tire-aspect-ratio-75"
    },
    {
      "value": "80",
      "handle": "tire-aspect-ratio-80"
    },
    {
      "value": "85",
      "handle": "tire-aspect-ratio-85"
    },
    {
      "value": "90",
      "handle": "tire-aspect-ratio-90"
    },
    {
      "value": "100",
      "handle": "tire-aspect-ratio-100"
    }
  ],
  "diameters": [
    {
      "value": "10",
      "handle": "tire-diameter-10"
    },
    {
      "value": "12",
      "handle": "tire-diameter-12"
    },
    {
      "value": "13",
      "handle": "tire-diameter-13"
    },
    {
      "value": "14",
      "handle": "tire-diameter-14"
    },
    {
      "value": "15",
      "handle": "tire-diameter-15"
    },
    {
      "value": "16",
      "handle": "tire-diameter-16"
    },
    {
      "value": "17",
      "handle": "tire-diameter-17"
    },
    {
      "value": "18",
      "handle": "tire-diameter-18"
    },
    {
      "value": "19",
      "handle": "tire-diameter-19"
    },
    {
      "value": "20",
      "handle": "tire-diameter-20"
    },
    {
      "value": "21",
      "handle": "tire-diameter-21"
    },
    {
      "value": "22",
      "handle": "tire-diameter-22"
    },
    {
      "value": "24",
      "handle": "tire-diameter-24"
    },
    {
      "value": "50",
      "handle": "tire-diameter-50"
    }
  ],
  "combinations": [
    {
      "width": {
        "value": "100",
        "handle": "tire-width-100"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "110",
        "handle": "tire-width-110"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "12.50",
        "handle": "tire-width-12-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "185",
        "handle": "tire-width-185"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "12",
        "handle": "tire-diameter-12"
      }
    },
    {
      "width": {
        "value": "70",
        "handle": "tire-width-70"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "20",
        "handle": "tire-aspect-ratio-20"
      },
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "25",
        "handle": "tire-aspect-ratio-25"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "10",
        "handle": "tire-width-10"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "345",
        "handle": "tire-width-345"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "15.00",
        "handle": "tire-width-15-00"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "2.50",
        "handle": "tire-width-2-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "130",
        "handle": "tire-width-130"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "12.50",
        "handle": "tire-width-12-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "10.50",
        "handle": "tire-width-10-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "140",
        "handle": "tire-width-140"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "100",
        "handle": "tire-width-100"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "110",
        "handle": "tire-width-110"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "100",
        "handle": "tire-width-100"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "80",
        "handle": "tire-width-80"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "12",
        "handle": "tire-diameter-12"
      }
    },
    {
      "width": {
        "value": "70",
        "handle": "tire-width-70"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "10",
        "handle": "tire-diameter-10"
      }
    },
    {
      "width": {
        "value": "80",
        "handle": "tire-width-80"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "70",
        "handle": "tire-width-70"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "70",
        "handle": "tire-width-70"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "60",
        "handle": "tire-width-60"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "60",
        "handle": "tire-width-60"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "12",
        "handle": "tire-diameter-12"
      }
    },
    {
      "width": {
        "value": "60",
        "handle": "tire-width-60"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "10",
        "handle": "tire-diameter-10"
      }
    },
    {
      "width": {
        "value": "65",
        "handle": "tire-width-65"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "11",
        "handle": "tire-width-11"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "10",
        "handle": "tire-diameter-10"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "10",
        "handle": "tire-diameter-10"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "12",
        "handle": "tire-diameter-12"
      }
    },
    {
      "width": {
        "value": "180",
        "handle": "tire-width-180"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "130",
        "handle": "tire-width-130"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "10",
        "handle": "tire-width-10"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "130",
        "handle": "tire-width-130"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "345",
        "handle": "tire-width-345"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "335",
        "handle": "tire-width-335"
      },
      "aspectRatio": {
        "value": "25",
        "handle": "tire-aspect-ratio-25"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "345",
        "handle": "tire-width-345"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "335",
        "handle": "tire-width-335"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "13",
        "handle": "tire-diameter-13"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "195",
        "handle": "tire-width-195"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "195",
        "handle": "tire-width-195"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "185",
        "handle": "tire-width-185"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "14",
        "handle": "tire-diameter-14"
      }
    },
    {
      "width": {
        "value": "185",
        "handle": "tire-width-185"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "13",
        "handle": "tire-diameter-13"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "195",
        "handle": "tire-width-195"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "305",
        "handle": "tire-width-305"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "13",
        "handle": "tire-width-13"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "50",
        "handle": "tire-diameter-50"
      }
    },
    {
      "width": {
        "value": "12",
        "handle": "tire-width-12"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "50",
        "handle": "tire-diameter-50"
      }
    },
    {
      "width": {
        "value": "12.50",
        "handle": "tire-width-12-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "385",
        "handle": "tire-width-385"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "315",
        "handle": "tire-width-315"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "285",
        "handle": "tire-width-285"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "85",
        "handle": "tire-aspect-ratio-85"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "85",
        "handle": "tire-aspect-ratio-85"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "15",
        "handle": "tire-width-15"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "50",
        "handle": "tire-diameter-50"
      }
    },
    {
      "width": {
        "value": "15.50",
        "handle": "tire-width-15-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "24",
        "handle": "tire-diameter-24"
      }
    },
    {
      "width": {
        "value": "14",
        "handle": "tire-width-14"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "50",
        "handle": "tire-diameter-50"
      }
    },
    {
      "width": {
        "value": "12.50",
        "handle": "tire-width-12-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "13.50",
        "handle": "tire-width-13-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "10",
        "handle": "tire-width-10"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "50",
        "handle": "tire-diameter-50"
      }
    },
    {
      "width": {
        "value": "265",
        "handle": "tire-width-265"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "85",
        "handle": "tire-aspect-ratio-85"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "19",
        "handle": "tire-diameter-19"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "235",
        "handle": "tire-width-235"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "225",
        "handle": "tire-width-225"
      },
      "aspectRatio": {
        "value": "35",
        "handle": "tire-aspect-ratio-35"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "205",
        "handle": "tire-width-205"
      },
      "aspectRatio": {
        "value": "40",
        "handle": "tire-aspect-ratio-40"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "195",
        "handle": "tire-width-195"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "195",
        "handle": "tire-width-195"
      },
      "aspectRatio": {
        "value": "45",
        "handle": "tire-aspect-ratio-45"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "185",
        "handle": "tire-width-185"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "215",
        "handle": "tire-width-215"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "150",
        "handle": "tire-width-150"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "110",
        "handle": "tire-width-110"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "180",
        "handle": "tire-width-180"
      },
      "aspectRatio": {
        "value": "70",
        "handle": "tire-aspect-ratio-70"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "200",
        "handle": "tire-width-200"
      },
      "aspectRatio": {
        "value": "55",
        "handle": "tire-aspect-ratio-55"
      },
      "diameter": {
        "value": "16",
        "handle": "tire-diameter-16"
      }
    },
    {
      "width": {
        "value": "160",
        "handle": "tire-width-160"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "190",
        "handle": "tire-width-190"
      },
      "aspectRatio": {
        "value": "50",
        "handle": "tire-aspect-ratio-50"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "120",
        "handle": "tire-width-120"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "11.50",
        "handle": "tire-width-11-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "90",
        "handle": "tire-width-90"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "80",
        "handle": "tire-width-80"
      },
      "aspectRatio": {
        "value": "100",
        "handle": "tire-aspect-ratio-100"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "3.00",
        "handle": "tire-width-3-00"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "2.75",
        "handle": "tire-width-2-75"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "100",
        "handle": "tire-width-100"
      },
      "aspectRatio": {
        "value": "90",
        "handle": "tire-aspect-ratio-90"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "100",
        "handle": "tire-width-100"
      },
      "aspectRatio": {
        "value": "80",
        "handle": "tire-aspect-ratio-80"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "2.75",
        "handle": "tire-width-2-75"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "7",
        "handle": "tire-width-7"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "10",
        "handle": "tire-diameter-10"
      }
    },
    {
      "width": {
        "value": "295",
        "handle": "tire-width-295"
      },
      "aspectRatio": {
        "value": "75",
        "handle": "tire-aspect-ratio-75"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "245",
        "handle": "tire-width-245"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "13.50",
        "handle": "tire-width-13-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "22",
        "handle": "tire-diameter-22"
      }
    },
    {
      "width": {
        "value": "11.50",
        "handle": "tire-width-11-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "17",
        "handle": "tire-diameter-17"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "25",
        "handle": "tire-aspect-ratio-25"
      },
      "diameter": {
        "value": "21",
        "handle": "tire-diameter-21"
      }
    },
    {
      "width": {
        "value": "255",
        "handle": "tire-width-255"
      },
      "aspectRatio": {
        "value": "30",
        "handle": "tire-aspect-ratio-30"
      },
      "diameter": {
        "value": "20",
        "handle": "tire-diameter-20"
      }
    },
    {
      "width": {
        "value": "12.50",
        "handle": "tire-width-12-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "11.50",
        "handle": "tire-width-11-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "9.50",
        "handle": "tire-width-9-50"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "13",
        "handle": "tire-width-13"
      },
      "aspectRatio": null,
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    },
    {
      "width": {
        "value": "275",
        "handle": "tire-width-275"
      },
      "aspectRatio": {
        "value": "60",
        "handle": "tire-aspect-ratio-60"
      },
      "diameter": {
        "value": "15",
        "handle": "tire-diameter-15"
      }
    },
    {
      "width": {
        "value": "325",
        "handle": "tire-width-325"
      },
      "aspectRatio": {
        "value": "65",
        "handle": "tire-aspect-ratio-65"
      },
      "diameter": {
        "value": "18",
        "handle": "tire-diameter-18"
      }
    }
  ]
};
